const presential_es = require('./presential.json')
export default presential_es